// client/src/hooks/useTabDirty.js
import { useContext, useEffect } from 'react';
import TabContext from '../context/TabContext';
import TabPaneContext from '../context/TabPaneContext';

/**
 * Marks the enclosing tab as holding unsaved work, so closing it asks first.
 *
 * Closing a tab unmounts its page for good — there is no undo for a half-filled
 * form the way there is for the tab itself. Pages with real in-progress state
 * call this; everything else needs no guard.
 *
 * No-ops in the untabbed shell, where there is no tab to close.
 *
 * @param isDirty  whether this page currently holds unsaved work
 * @param message  what to warn about, e.g. "This order has not been created yet."
 */
export default function useTabDirty(isDirty, message) {
  const tabs = useContext(TabContext);
  const tabId = useContext(TabPaneContext);
  const setTabDirtyFor = tabs?.setTabDirtyFor;

  useEffect(() => {
    if (!setTabDirtyFor || !tabId) return undefined;
    setTabDirtyFor(tabId, isDirty ? message || true : null);
    return () => setTabDirtyFor(tabId, null);
  }, [setTabDirtyFor, tabId, isDirty, message]);
}
